import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { withWindowSize } from "react-fns";
import styled from 'styled-components';
import { compose } from "redux";
import { Button, ClickAwayListener, ListItem } from "@material-ui/core";
import { Lock } from "@material-ui/icons";
import Logo from "lib/images/LBLogomark.svg";
import homeIcon from "lib/images/home.svg";
import { withStyles } from "@material-ui/core/styles";
import UserMenu from "./UserMenu";
import NotificationsMenu from './NotificationsMenu';
import ViewAsBanner from "components/Admin/ViewAsBanner";
import { getCompanies } from "store/state/companies";
import { poll, getHeartbeatInterval } from "store/state/heartbeat";
import SimpleInfoDialog from 'components/Global/ConfirmationDialogs/SimpleInfoDialog';
import { logoutRequest } from "store/state/auth";
import {ROUTE_DASHBOARD, ROUTE_BROKER_DASHBOARD} from 'constants/routes';
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import featureFlags from "constants/featureFlags";
import { getEnvConfig } from "helpers/environment-config";

const styles = {
  root: {
    background: "#ffffff"
  },
  toolbarRoot: {
    minHeight: '50px',
    margin: "auto",
    width: "1104px",
  },
  drawerPaper: {
    background: "#55555f",
    marginTop: '50px',
    width: '200px',

  },
  button: {
    backgroundColor: "rgba(15, 144, 208, 1)",
    color: "#fff",
    width: "150px",
    borderRadius: "20px",
    fontFamily: "Roboto",
    margin: "5px",
    "&:hover": {
      backgroundColor: "rgba(15, 144, 208, .7)"
    }
  },
  label: {
    fontFamily: "Roboto",
    color: "#000",
    fontWeight: "100",
    letterSpacing: "1px"
  }
};

const ItemGroup = styled.div`
  display: flex;
  flex-flow: row;
`;

const NavListItem = styled(ListItem)`
  && * {
    color: #000;
  }
`;

const FlexNav = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  & * {
    font-size: 16px;
    margin: 0 4px;
  }
`;

const StyledItemGroup = styled(ItemGroup)`
  position: absolute;
  right: 0px;
`;

const StyledNavListItem = styled(NavListItem)` &&&&& {
  background-color: white;
  margin: auto;
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
}`;

const BlueLink = styled.div` &&& {
  color: #005AA9;
}`;

const BlackLink = styled.div` &&& {
  color: #5F6368;
}`;

const StyledImage = styled.img` &&&{  
  width: 150px;
}`;

const TopNavContainer = styled.div`
  margin: auto;
  background: #FFFFFF;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: space-between;
  max-width: 1120px;
  min-width: 1120px;
`;

const TopNavItemWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;  
  width: 100%;
  margin-top: 10px;
  padding-bottom: 0px;
`;

const TopNavItemContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: ${(props) => props.justifyContent};
  width: 100%;
  margin-left: 16px;
  margin-right: 16px;
`;

const StyledLink = styled(Link)`&&& {
  pointer-events: ${({ disabled }) => disabled ? "none" : ""};
}`;

const TopNavItem = ({ label, icon, link, callback, trailingIcon, pathName }) => (
  <StyledNavListItem button component={Link} to={link} activeClassname="selected" onClick={callback}>
    <FlexNav>
      {icon}
      {pathName === link && <BlueLink id={`leftNav-${label.toUpperCase()}`}>{label}</BlueLink>}
      {pathName !== link && <BlackLink id={`leftNav-${label.toUpperCase()}`}>{label}</BlackLink>}
      {trailingIcon}
    </FlexNav>
  </StyledNavListItem>
);

export class MainTopNavigation extends Component {
  state = {
    drawerOpen: false,
    popupOpen: false
  };

  componentDidMount() {
    this.props.getHeartbeatInterval();
  }

  componentDidUpdate(prevProps) {
    if (!this.props.heartbeat.isActive && prevProps.heartbeat.isActive) {
      this.props.logoutRequest();
    }
  }

  startHeartbeat = () => {
    if (!this.state.heartbeatStarted) {
      setInterval(this.props.poll, this.props.heartbeat.interval * 60000);
      this.setState({ heartbeatStarted: true });
    }
  }

  handleDrawerOpen = () => {
    this.setState({ drawerOpen: true });
  };

  handleDrawerClose = (showRestrictedModal) => {
    this.setState({ drawerOpen: false, popupOpen: showRestrictedModal });
    document.getElementById("mainContent").style.marginLeft = "0px";
  };

  handleLogout = () => {
    document.getElementById("mainContent").style.marginLeft = "0px";
    this.setState({ drawerOpen: false });
  };

  toggleDrawer = (side, open) => () => this.setState({ [side]: open });

  renderViewAsBanner = () => this.props.authentication.isSystemAdmin ? <ViewAsBanner></ViewAsBanner> : null
  closePopup = () => {
    this.setState({ popupOpen: false });
  }

  isProTier = () => this.props.authentication && (this.props.authentication.companyLevel === "Professional" || this.props.authentication.companyLevel === "Enterprise" || this.props.authentication.companyLevel === "Secondary Sponsor")

  hasGuestOnlyAccess = () => this.props.authentication && this.props.authentication.guestAccess === "guest";

  hasBrokerAccess = () => {
    if (!this.props.authentication) return false;

    let companyTypes = this.props.authentication.companyTypes;
    if (this.props.authentication.isGuest) {
      if (!this.props.companies || !this.props.companies.company)
        return false;
      companyTypes = this.props.companies.company.companyTypes;
    }

    return companyTypes.map(ct => ct.name).includes('Broker');
  }

  goToRequestDemo = () => {
    window.open('https://www.loanboss.com/request-a-demo/?utm_source=website&utm_medium=topnav&utm_campaign=bluebutton');
  }

  goToRedesignedFrontEndHome = async () => {
    const newFrontendUrl = await getEnvConfig("newFrontendUrl");
    window.location.assign(`${newFrontendUrl}/home`);
  };

  renderFeatureLockedModel = () => <SimpleInfoDialog
    title="Feature Locked"
    message="This feature is only available if you upgrade your account."
    modalOpen={this.state.popupOpen}
    handleClose={this.closePopup}
    handleAccept={this.closePopup}
    secondaryContent={
      <p>
        If you would to schedule a demo to view these features, contact <a href="mailto:sales@loanboss.com">sales@loanboss.com</a>. <br /> <br />
        Please contact your LoanBoss Administrator to upgrade or if you believe you are seeing this message in error: <a href="mailto:support@loanboss.com">support@loanboss.com</a>.
      </p>
    } />

  us1632FeatureFlag = () =>
    this.props.flags[featureFlags.US1632_DOMO_REPORTING_PAGE];

  bar1837FeatureFlagShowOnboardingNavLink = () =>
    this.props.flags[featureFlags.BAR1837_SHOW_ONBOARDING_NAV_LINK];

  shouldShowTopMenuItems = () => {
    const { pathname } = window.location;
    const minimalNavPaths = ["/reporting", "/lenderReportingDashboard", "/loans"];
    return !minimalNavPaths.some(p => pathname.startsWith(p))
      && pathname !== "/onboarding"
      && !/^\/deal\/[^/]+\/lender-reports/.test(pathname);
  };

  renderTopApplicationBar() {
    const { authentication: { authed, user }, classes, isHidden, companyId } = this.props;

    const isProTier = this.isProTier();
    const hasGuestOnlyAccess = this.hasGuestOnlyAccess();
    const isGuestLandingUrl = window.location.pathname === "/guestlanding";
    const isAuthorizedAndNotGuestUrl = !isGuestLandingUrl && authed;
    const notificationsMenuIsVisible = isProTier && !hasGuestOnlyAccess && !isHidden;
    const userPrefersBrokerDashboardView = user.prefersBrokerDashboardView;
    const showTopMenuItems = this.shouldShowTopMenuItems();
    const dashboardRoute = userPrefersBrokerDashboardView ? ROUTE_BROKER_DASHBOARD : ROUTE_DASHBOARD;
    const shouldShowShowOnboardingNavLink = (this.bar1837FeatureFlagShowOnboardingNavLink() ?? []).includes(companyId);
    const renderHomeLink = () => {
      if(showTopMenuItems) {
        return (<StyledLink to={dashboardRoute} disabled={isHidden}><StyledImage src={Logo} id="homeLogo" className="App-logo" alt="logo" /></StyledLink>);
        }

        return (<Button onClick={this.goToRedesignedFrontEndHome} className="home-link-btn">
                  <StyledImage src={homeIcon} id="homeIcon" className="home-icon" alt="home icon" />
                  <span className="home-label">Home</span></Button>);
      };
    return (
      <TopNavContainer id="ScrollToNav">
        <TopNavItemWrapper>
          <TopNavItemContainer justifyContent="start">
            {renderHomeLink()}
          </TopNavItemContainer>
          <TopNavItemContainer>
            {!isGuestLandingUrl && !authed && window.location.pathname === "/login" && (<StyledItemGroup><Button id="getStartedButton" className={classes.button} onClick={this.goToRequestDemo}>GET STARTED</Button></StyledItemGroup>)}
            {!isHidden && isAuthorizedAndNotGuestUrl && showTopMenuItems &&
              <>
                {!userPrefersBrokerDashboardView && this.renderNavItem("Deals", dashboardRoute, false, null, this.props.location.pathname)}
                {this.us1632FeatureFlag() && this.renderNavItem("Reporting", `/reporting`, true, null, this.props.location.pathname)}
                {this.renderNavItem("Apps", "/apps", false, null, this.props.location.pathname)}
                {shouldShowShowOnboardingNavLink && this.renderNavItem("Onboard", `/onboarding`, true, null, this.props.location.pathname)}
              </>
            }
          </TopNavItemContainer>
          <TopNavItemContainer justifyContent="end">
            {isAuthorizedAndNotGuestUrl &&
              <>
                <UserMenu user={user} disabled={isHidden} isStatic={!showTopMenuItems} />
                {notificationsMenuIsVisible && <NotificationsMenu />}
              </>
            }
          </TopNavItemContainer>
        </TopNavItemWrapper>
        <TopNavItemWrapper>
          {this.props.authentication.isSystemAdmin && <ViewAsBanner></ViewAsBanner>}
          {authed && this.startHeartbeat()}
        </TopNavItemWrapper>
      </TopNavContainer>);
  }

  renderNavItem(label, link, requireProTier, icon, pathName) {
    const isProTier = this.isProTier();
    const hasGuestOnlyAccess = this.hasGuestOnlyAccess();

    const isLocked = hasGuestOnlyAccess || (requireProTier && !isProTier);
    const showRestrictedModal = isLocked;

    return <TopNavItem
      label={label}
      icon={isLocked ? <Lock /> : icon}
      link={isLocked ? "" : link}
      callback={() => this.handleDrawerClose(showRestrictedModal)}
      pathName={pathName} />
  }

  render() {
    return (
      <ClickAwayListener onClickAway={() => this.handleDrawerClose(false)}>
        {this.renderTopApplicationBar()}
        {this.renderFeatureLockedModel()}
      </ClickAwayListener>
    );
  }
}

const mapStateToProps = ({ authentication, companies, heartbeat }) => ({
  authentication,
  heartbeat,
  companies: companies.companiesPage ? companies.companiesPage.companies : [],
  companyId: authentication?.user?.contact?.company?.id
});

export default compose(
  withRouter,
  withLDConsumer(),
  connect(mapStateToProps,
    { getCompanies, poll, getHeartbeatInterval, logoutRequest }),
  withWindowSize,
  withStyles(styles),
)(MainTopNavigation);
